// newsApi API
import ajax from './_ajax';

const api = {};
api.newsGetPagedList = function (params) {
  return ajax.post('/api/News/GetPagedList', params);
};
api.newsGetDetail = function (id) {
  return ajax.get('/api/News/GetDetail?id=' + id);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/newsApi.js